<template>
  <NText weight="bold" variant="caption1">
    {{ title }}
  </NText>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface Props {
  title: string;
}

defineProps<Props>();
</script>
